// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__jkJgm","item_a":"Navbar_item_a__Hi8xO"};